import { settings } from "app";
import permissions from "app/permissions";
import { getPermissions } from "auth/security/securityUtils";
import React from "react";
import { Datagrid, EditButton, FunctionField, List, ListActions, ShowButton, SimpleList, TextField } from "react-admin";
import { useMediaQuery } from "@mui/material";
import SecuredComponent from "server/security/SecuredComponent";
import { checkPermission } from "server/security/utils";
import { MOBILE_BREAKPOINT } from "utils/constants";
import { MobileListRow } from "features/MobileListRow";
import DeactivateDialog from "./DeactivateDialog";

const ListWards = () => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);

  return (
    <List
      title="Болнични отделения"
      exporter={false}
      sx={settings.style.expandStyle}
      actions={<ListActions hasCreate={checkPermission(getPermissions(), permissions.canManageWards)} />}
    >
      {isMobile ? (
        <SimpleList
          linkType={false}
          sx={settings.style.mobileList}
          primaryText={record => (
            <MobileListRow fields={[{ label: "Има на български", value: record?.nameBg }]} />
          )}
          secondaryText={record => (
            <div>
              <MobileListRow fields={[{ label: "Има на английски", value: record?.nameEn }]} />
              <MobileListRow
                fields={[{ label: "Статус", value: record?.isActive ? "Активна" : "Неактивна" }]}
              />
              <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
                {record.isActive && (
                  <DeactivateDialog
                    wardName={record?.nameBg}
                    id={record?.id}
                  />
                )}
              </div>
            </div>
          )}
          tertiaryText={() => (
            <>
              <SecuredComponent permission={permissions.canPreviewWards}>
                <ShowButton label="" />
              </SecuredComponent>
              <SecuredComponent permission={permissions.canManageWards}>
                <EditButton label="" />
              </SecuredComponent>
            </>
          )}
        />
      ) : (
        <Datagrid
          bulkActionButtons={false}
          rowClick={false}
        >
          <TextField
            source="nameBg"
            label="Има на български"
          />
          <TextField
            source="nameEn"
            label="Има на английски"
          />
          <FunctionField
            label="Статус"
            render={rec => (rec?.isActive ? "Активна" : "Неактивна")}
          />
          <FunctionField
            render={rec =>
              rec.isActive && (
                <DeactivateDialog
                  wardName={rec?.nameBg}
                  id={rec?.id}
                />
              )
            }
          />
          <SecuredComponent permission={permissions.canPreviewWards}>
            <ShowButton />
          </SecuredComponent>
          <SecuredComponent permission={permissions.canManageWards}>
            <EditButton />
          </SecuredComponent>
        </Datagrid>
      )}
    </List>
  );
};

export default ListWards;
